import { createRouter, createWebHashHistory } from 'vue-router'
import HomeView from './views/HomeView.vue'
import CatalogView from './views/CatalogView.vue'
import ItemDetailView from './views/ItemDetailView.vue'
import BasketView from './views/BasketView.vue'
import SolutionPreviewView from './views/SolutionPreviewView.vue'
import CompanyView from './views/CompanyView.vue'
import StatusView from './views/StatusView.vue'
import SoftwareDemoView from './views/SoftwareDemoView.vue'
import CabinetGeneratorView from './views/CabinetGeneratorView.vue'
import ControllerIoView from './views/ControllerIoView.vue'
import TerminalDevicesView from './views/TerminalDevicesView.vue'
import { runtimeConfig } from './platform/runtime'

export const router = createRouter({
  history: createWebHashHistory(),
  scrollBehavior: () => ({ top: 0 }),
  routes: [
    { path: '/', name: 'home', component: HomeView },
    {
      path: '/catalog/:section(hardware|software|cases)',
      name: 'catalog',
      component: CatalogView
    },
    { path: '/item/:id', name: 'item', component: ItemDetailView },
    { path: '/software-demo/:id', name: 'software-demo', component: SoftwareDemoView },
    {
      path: '/cabinet-generator',
      name: 'cabinet-generator',
      component: CabinetGeneratorView
    },
    {
      path: '/controller-io',
      name: 'controller-io',
      component: ControllerIoView
    },
    {
      path: '/terminal-devices',
      name: 'terminal-devices',
      component: TerminalDevicesView
    },
    {
      path: '/simulation',
      redirect: () =>
        runtimeConfig.mode === 'mobile-public'
          ? { name: 'home' }
          : { name: 'home', query: { focus: 'simulation' } }
    },
    { path: '/basket', name: 'basket', component: BasketView },
    {
      path: '/solution-preview',
      name: 'solution-preview',
      component: SolutionPreviewView
    },
    { path: '/company', name: 'company', component: CompanyView },
    { path: '/status', name: 'status', component: StatusView },
    { path: '/:pathMatch(.*)*', redirect: '/' }
  ]
})
